import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';
import { Calendar, User } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const ClientDashboard = () => {
  const { user } = useAuth();
  const [sessions, setSessions] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [coach, setCoach] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/portal/sessions`, { withCredentials: true }).then(r => setSessions(r.data)).catch(() => {});
    axios.get(`${API}/api/portal/questions`, { withCredentials: true }).then(r => setQuestions(r.data)).catch(() => {});
    axios.get(`${API}/api/portal/my-coach`, { withCredentials: true }).then(r => setCoach(r.data)).catch(() => {});
  }, []);

  const nextSession = sessions.find(s => new Date(s.session_date) >= new Date());

  return (
    <div data-testid="client-dashboard">
      <h1 className="portal-page-title">Welcome back, {user?.name?.split(' ')[0]}</h1>
      <p className="portal-page-subtitle">Your R6 Advisory Portal</p>

      {/* Coach Card */}
      {coach && (
        <div className="portal-card" style={{ marginBottom: '1.5rem', background: 'linear-gradient(135deg, #1B2A4E 0%, #2D3F6B 100%)', color: 'white' }} data-testid="coach-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'rgba(200,150,62,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <User size={24} color="#C8963E" />
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ margin: 0, fontSize: '0.78rem', color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 600 }}>Your Advisor</p>
              <h3 style={{ margin: '0.15rem 0 0', fontSize: '1.05rem', fontWeight: 700 }}>{coach.name}</h3>
              {coach.bio && <p style={{ margin: '0.3rem 0 0', fontSize: '0.85rem', opacity: 0.7, lineHeight: 1.4 }}>{coach.bio}</p>}
            </div>
            {coach.calendly_link && (
              <a href={coach.calendly_link} target="_blank" rel="noopener noreferrer" className="portal-btn" data-testid="book-session-btn" style={{
                background: '#C8963E', color: 'white', border: 'none', padding: '0.6rem 1.2rem',
                borderRadius: 8, fontWeight: 700, fontSize: '0.82rem', textDecoration: 'none',
                display: 'flex', alignItems: 'center', gap: '0.4rem', flexShrink: 0, fontFamily: 'Montserrat, sans-serif',
              }}>
                <Calendar size={16} /> Book Session
              </a>
            )}
          </div>
        </div>
      )}

      <div className="portal-grid-2">
        <div className="portal-card">
          <span className="portal-badge">Next Session</span>
          {nextSession ? (
            <>
              <p className="portal-stat-value">{new Date(nextSession.session_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</p>
              <p>{nextSession.duration}</p>
            </>
          ) : (
            <>
              <p className="portal-stat-value">None</p>
              <p>No upcoming sessions scheduled</p>
            </>
          )}
        </div>
        <div className="portal-card">
          <span className="portal-badge">Questions Submitted</span>
          <p className="portal-stat-value">{questions.length}</p>
          <p>Pre-session questions on file</p>
        </div>
      </div>

      <div className="portal-card" style={{ marginTop: '1.5rem' }}>
        <h3>Quick Actions</h3>
        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', flexWrap: 'wrap' }}>
          {coach?.calendly_link ? (
            <a href={coach.calendly_link} target="_blank" rel="noopener noreferrer" className="portal-btn portal-btn-primary" data-testid="quick-book-btn">Book a Session</a>
          ) : (
            <span className="portal-btn" style={{ background: '#F1F3F5', color: '#9CA3AF', cursor: 'default' }}>No coach assigned yet</span>
          )}
          <Link to="/portal/questions" className="portal-btn portal-btn-outline">Submit Questions</Link>
          <Link to="/portal/resources" className="portal-btn portal-btn-outline">Browse Resources</Link>
        </div>
      </div>

      {sessions.length > 0 && (
        <div className="portal-card" style={{ marginTop: '1.5rem' }}>
          <h3>Recent Sessions</h3>
          {sessions.slice(0, 3).map(s => (
            <div key={s.id} style={{ borderBottom: '1px solid #F1F3F5', padding: '0.75rem 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <strong style={{ color: '#1B2A4E', fontSize: '0.92rem' }}>{s.session_date}</strong>
                  <span style={{ color: '#5A6C8A', fontSize: '0.82rem', marginLeft: '0.75rem' }}>{s.duration}</span>
                </div>
              </div>
              <p style={{ fontSize: '0.88rem', color: '#4A5568', margin: '0.25rem 0 0' }}>{s.summary?.substring(0, 120)}...</p>
            </div>
          ))}
          <Link to="/portal/sessions" style={{ display: 'inline-block', marginTop: '0.75rem', color: '#C8963E', fontWeight: 600, fontSize: '0.88rem', textDecoration: 'none' }}>View all sessions</Link>
        </div>
      )}
    </div>
  );
};

export default ClientDashboard;
